import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { Router } from '@angular/router'
import { finalize } from 'rxjs/operators'

import { ResultCode } from '../../../domain/authentication.model'
import { AuthService } from '../../../services/auth.service'
import { NotificationService } from '../../../services/notification.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-login-form',
  templateUrl: './bmcore-login-form.component.html',
  styleUrls: ['./bmcore-login-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreLoginFormComponent implements OnInit {
  lg: LgType
  loginForm: UntypedFormGroup
  isLoader = false

  constructor(
    private authService: AuthService,
    private router: Router,
    private notificationService: NotificationService,
    private formBuilder: UntypedFormBuilder,
    private i18nService: I18nService
  ) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()

    // https://coryrylan.com/blog/building-reusable-forms-in-angular
    this.loginForm = this.formBuilder.group({
      email: [],
      password: []
    })
  }

  submit() {
    if (this.loginForm.valid) {
      this.isLoader = true

      const { email, password } = this.loginForm.value

      this.authService
        .login(email.email, password.password)
        .pipe(finalize(() => (this.isLoader = false)))
        .subscribe(
          res => {
            if (res.resultCode === ResultCode.Success) {
              this.router.navigate(['/'])
            } else {
              this.notificationService.handleError(res.messages[0])
            }
          },
          err => this.notificationService.handleError(err.message)
        )
    } else {
      this.notificationService.handleError(this.lg.forms.error)
    }
  }
}
